import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

// import 'bootstrap/dist/css/bootstrap.min.css';
// flatly | lumen | lux | simplex | united | yeti
// lumen | lux
// import 'bootswatch/dist/lux/bootstrap.min.css'; // Added this :boom:
import './index.css';
import './index.scss';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import authReducer from './store/reducers/auth';
import scheduleReducer from './store/reducers/schedule';
import settingReducer from './store/reducers/setting';
import appointmentReducer from './store/reducers/appointment';
import appointmentHistoryReducer from './store/reducers/appointmentHistory';
import relationReducer from './store/reducers/relation';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-163482812-2');
ReactGA.pageview(window.location.pathname + window.location.search);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    auth: authReducer,
    setting: settingReducer,
    appointment: appointmentReducer,
    appointmentHistory: appointmentHistoryReducer,
    schedule: scheduleReducer,
    relation: relationReducer,
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

ReactDOM.render( app, document.getElementById( 'root' ) );
registerServiceWorker();
// serviceWorker.unregister();




// WEBPACK FOOTER //
// ./src/index.js